module.exports = __webpack_public_path__ + "static/6-4dd9532e051fa16e51f068c0ac3cbeb7.jpg";